import { BUTTON_RESET, CARD } from "../../styles";

export function Modal({ titulo, onClose, children, maxWidth = 560 }) {
  return (
    <div
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(11,18,24,.64)",
        zIndex: 1200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          ...CARD,
          width: "100%",
          maxWidth,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "18px 20px 14px",
            borderBottom: "1px solid #EEF3F6",
          }}
        >
          <div style={{ fontWeight: 900, color: "#1F2937", fontSize: 17 }}>
            {titulo}
          </div>
          <button
            onClick={onClose}
            style={{
              ...BUTTON_RESET,
              background: "transparent",
              color: "#94A3B8",
              fontSize: 20,
            }}
          >
            x
          </button>
        </div>
        <div style={{ padding: 20 }}>{children}</div>
      </div>
    </div>
  );
}
